import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ArchitectureStructureSettingModel} from '../../../../models/ArchitectureStructureSettingModel';
import {ResourceUnitFilterComponent} from '../../../general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {Sl1FilterComponent} from '../../../general-components/filter/sl1-filter/sl1-filter.component';
import {Sl3FilterComponent} from '../../../general-components/filter/sl3-filter/sl3-filter.component';
import {Sl4FilterComponent} from '../../../general-components/filter/sl4-filter/sl4-filter.component';
import {Sl5FilterComponent} from '../../../general-components/filter/sl5-filter/sl5-filter.component';
import {Sl2FilterComponent} from '../../../general-components/filter/sl2-filter/sl2-filter.component';
import {UnitsFilterComponent} from '../../../general-components/filter/units-filter/units-filter.component';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import { Offset } from 'src/models/Offset';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {ArchitectureStructureService} from '../service/architecture-structure.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {Sl1AnagrafService} from '../../../general-services/service-sl1-services/sl1-anagraf.service';
import {MatDialog} from '@angular/material/dialog';
import {Sl2AnagrafService} from '../../../general-services/service-sl2-anagraf/sl2-anagraf.service';
import {Sl3AnagrafService} from '../../../general-services/service-sl3-anagraf/sl3-anagraf.service';
import {SL4AnagrafService} from '../../../general-services/service-sl4-anagraf/sl4-anagraf.service';
import {SL5AnagrafService} from '../../../general-services/service-sl5-anagraf/sl5-anagraf.service';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {UnitsAnagrafService} from '../../../general-services/service-units-anagraf/units-anagraf.service';
import {ProviderFilterComponent} from '../../../general-components/filter/provider-filter/provider-filter.component';
import {BaseGeneralComponent} from "../../../BaseGeneralComponent";


@Component({
  selector: 'app-filter-architecture',
  templateUrl: './filter-architecture.component.html',
  styleUrls: ['./filter-architecture.component.scss']
})
export class FilterArchitectureComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() providerData?: any;
  @Input() filter?: ArchitectureStructureSettingModel;

  sl1: any;
  sl2: any;
  sl3: any;
  sl4: any;
  sl5: any;
  unitsData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(Sl1FilterComponent) sl1FilterComponent;
  @ViewChild(Sl2FilterComponent) sl2FilterComponent;
  @ViewChild(Sl3FilterComponent) sl3FilterComponent;
  @ViewChild(Sl4FilterComponent) sl4FilterComponent;
  @ViewChild(Sl5FilterComponent) sl5FilterComponent;
  @ViewChild(UnitsFilterComponent) unitsFilterComponent;
  @ViewChild(ResourceUnitFilterComponent) resourceUnitFilterComponent;
  @ViewChild(ProviderFilterComponent) providerFilterComponent;

  filterSingle: ArchitectureStructureSettingModel;
  getNameSubscribe: Subscription;
  offset: Offset;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private architectureStructureService: ArchitectureStructureService,
              private providerService: ProviderAnagrafService,
              private sl1Service: Sl1AnagrafService,
              private sl2Service: Sl2AnagrafService,
              private sl3Service: Sl3AnagrafService,
              private sl4Service: SL4AnagrafService,
              private sl5Service: SL5AnagrafService,
              private resourceUnitService: ResourceUnitService,
              private unitsService: UnitsAnagrafService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ArchitectureStructureSettingModel();
    }
    this.filterSingle = ArchitectureStructureSettingModel.clone(this.filter);
    this.offset = new Offset(10, 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER));
    }
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allArchitectureStructure: ArchitectureStructureSettingModel, isReset?: boolean) {

    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2Observable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3Observable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4Observable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5Observable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();


    forkJoin([getAllSl1Observable, getAllResourceUnitObservable, getAllUnitObservable,
                      getAllSl2Observable, getAllSl3Observable, getAllSl4Observable, getAllSl5Observable])
      .subscribe(
        (resultFork: any) => {
          this.sl1 = resultFork[0];
          this.resourceUnitData = resultFork[1];
          this.unitsData = resultFork[2];
          this.sl2 = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];
          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
        });


  }

  interceptProviderChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.provider = event;


    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1FilteredObservable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();


    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl1FilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllSl4FilteredObservable);
    observableList.push(getAllSl5FilteredObservable);


    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.sl1 = resultFork[0];
          this.resourceUnitData = resultFork[1];
          this.unitsData = resultFork[2];
          this.sl2 = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
    }

  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.designServices = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllSl4FilteredObservable);
    observableList.push(getAllSl5FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.resourceUnitData = resultFork[1];
          this.unitsData = resultFork[2];
          this.sl2 = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllL4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllL5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllL4FilteredObservable);
    observableList.push(getAllL5FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.unitsData = resultFork[2];
          this.sl2 = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.units = this.filterSingle.units;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptUnitChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.units = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllSl4FilteredObservable);
    observableList.push(getAllSl5FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.sl2 = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptLayerChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.layer = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllL2FSl4teredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllL2FSl4teredObservable);
    observableList.push(getAllSl5FilteredObservable);


    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.unitsData = resultFork[3];
          this.sl3 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptL1Change(event) {
    this.loaderService.display(true);
    this.intermittentFilterButton(true);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.l1 = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl4FilteredObservable);
    observableList.push(getAllSl5FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.unitsData = resultFork[3];
          this.sl2 = resultFork[4];
          this.sl4 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l2 = this.filterSingle.l2;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptL2Change(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.l2 = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl5FilteredObservable: Observable<any> = this.sl5Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllSl5FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.unitsData = resultFork[3];
          this.sl2 = resultFork[4];
          this.sl3 = resultFork[5];
          this.sl5 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l3 = this.filterSingle.l3;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  interceptL3Change(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.l3 = this.filterSingle.l3;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl1Observable: Observable<any> = this.sl1Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllUnitFilteredObservable: Observable<any> = this.unitsService.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl2FilteredObservable: Observable<any> = this.sl2Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl3FilteredObservable: Observable<any> = this.sl3Service.getListInArchitectureStructure(this.filterSingle).pipe();
    const getAllSl4FilteredObservable: Observable<any> = this.sl4Service.getListInArchitectureStructure(this.filterSingle).pipe();

    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllSl1Observable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllUnitFilteredObservable);
    observableList.push(getAllSl2FilteredObservable);
    observableList.push(getAllSl3FilteredObservable);
    observableList.push(getAllSl4FilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.sl1 = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.unitsData = resultFork[3];
          this.sl2 = resultFork[4];
          this.sl3 = resultFork[5];
          this.sl4 = resultFork[6];

          this.filter.provider = this.filterSingle.provider;
          this.filter.designServices = this.filterSingle.designServices;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.units = this.filterSingle.units;
          this.filter.layer = this.filterSingle.layer;
          this.filter.l1 = this.filterSingle.l1;
          this.filter.l2 = this.filterSingle.l2;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
        });
  }

  filterTable(): void {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.getAllFilters();

    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER, JSON.stringify(this.filter));

    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    const isReset = true;
    this.filter = new ArchitectureStructureSettingModel();
    this.filterSingle = new ArchitectureStructureSettingModel();

    const getFirstProviderObservable: Observable<any> = this.providerService.getListInArchitectureStructure(this.filterSingle).pipe();

    getFirstProviderObservable
      .subscribe(
        (result: any) => {
          this.providerData = result;

          this.filter.provider = result ? result[0] : null;

          sessionStorage.setItem(this.SESSION_STORAGE_LABELS.ARCHITECTURE_STRUCTURE_SETTING_FILTER, JSON.stringify(this.filter));
          this.filterSingle = new ArchitectureStructureSettingModel();

          this.initFilter(this.filterSingle, isReset);
        }, error => {
          console.log(error);
        });
  }

  getAllFilters() {
    this.filter.designServices = this.sl1FilterComponent.optionSelected;
    this.filter.l1 = this.sl3FilterComponent.optionSelected;
    this.filter.l2 = this.sl4FilterComponent.optionSelected;
    this.filter.l3 = this.sl5FilterComponent.optionSelected;
    this.filter.layer = this.sl2FilterComponent.optionSelected;
    this.filter.units = this.unitsFilterComponent.optionSelected;
    this.filter.resourceUnit = this.resourceUnitFilterComponent.optionSelected;
    this.filter.provider = this.providerFilterComponent.optionSelected;
  }

  ngOnDestroy(): void {
  }

}

